import { IPoolChart } from './pool-chart.interface';
export interface IPoolDistribution {
  id:number;
  name:string;
  poolType:string;
  poolCharts:IPoolChart[];
  isActive:boolean;
  status:string;
}
